import React from 'react';
import Fetch from 'react-fetch-component';

import { Navigate, useNavigate } from 'react-router-dom';
import { fetchContainerPropTypes } from '../../types';
import Loader from '../../components/Loader';
import Error from '../../components/Error';

const renderDefaultLoader = (formatMessage, text, theme) => () =>
    <Loader type="linear" text={ text || formatMessage('loader.loading') } theme={ theme } />;

const renderDefaultError = (text, theme) => onClickHandlers => (
    <Error onClickHandlers={ onClickHandlers } text={ text } theme={ theme } />
);

const FetchContainer = ({
    url,
    options,
    children: renderContent,
    i18n: { formatMessage },
    theme,
    loaderText,
    errorText,
    renderLoader = renderDefaultLoader(formatMessage, loaderText, theme),
    renderError = renderDefaultError(errorText, theme),
}) => {
    const navigate = useNavigate();

    return (
        <Fetch url={ url } options={ options }>
            {({
                data,
                loading,
                error,
                fetch,
            }) => {
                if (!loading && error && error.statusCode < 500) {
                    return <Navigate to="/404" />;
                }

                return (
                    <>
                        {data && renderContent(data)}
                        {loading && renderLoader()}
                        {
                            !loading && error && renderError({
                                cancel: () => navigate(CONFIG.basePath),
                                retry: () => fetch(url, options),
                            })
                        }
                    </>
                );
            }}
        </Fetch>
    );
};

const defaultProps = {
    errorText: '',
    loaderText: '',
    renderLoader: undefined,
    renderError: undefined,
};

FetchContainer.propTypes = fetchContainerPropTypes;
FetchContainer.defaultProps = defaultProps;

export default FetchContainer;
export {
    defaultProps,
};
